class UltraPersonal extends HTMLElement {
    connectedCallback() {
        this._bindToggles();
        this._initOpenPanels();
        this._observePanelResize();
    }

    _bindToggles() {
        const toggles = this.querySelectorAll('.js-ultra-personal-toggle');
        const clickToggles = this.querySelector('.ultra-personal__figure--has-hover');
        toggles.forEach((btn) => {
            btn.addEventListener('click', () => this._handleToggle(btn));
        });
        clickToggles.addEventListener('click', () => {
            clickToggles.classList.toggle('ultra-personal__figure--active');
        });
    }

    _initOpenPanels() {
        const openPanels = this.querySelectorAll(
            '.ultra-personal__accordion-item--open .ultra-personal__accordion-panel',
        );
        openPanels.forEach((panel) => {
            this._syncPanelHeight(panel, true);
        });
    }

    _observePanelResize() {
        const inners = this.querySelectorAll('.ultra-personal__accordion-panel-inner');
        if (inners.length === 0 || typeof ResizeObserver === 'undefined') {
            return;
        }

        this._resizeObserver = new ResizeObserver(() => {
            this.querySelectorAll('.ultra-personal__accordion-item--open').forEach((item) => {
                const panel = item.querySelector('.ultra-personal__accordion-panel');
                if (panel) {
                    this._syncPanelHeight(panel, true);
                }
            });
        });

        inners.forEach((el) => this._resizeObserver.observe(el));
    }

    disconnectedCallback() {
        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
        }
    }

    _handleToggle(btn) {
        const item = btn.closest('.ultra-personal__accordion-item');
        if (!item) {
            return;
        }

        const panel = item.querySelector('.ultra-personal__accordion-panel');
        const willOpen = !item.classList.contains('ultra-personal__accordion-item--open');

        item.classList.toggle('ultra-personal__accordion-item--open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

        if (panel) {
            this._syncPanelHeight(panel, willOpen);
        }
    }

    _syncPanelHeight(panel, open) {
        const inner = panel.querySelector('.ultra-personal__accordion-panel-inner');
        if (!inner) {
            return;
        }

        if (open) {
            panel.style.maxHeight = `${inner.scrollHeight}px`;
        } else {
            panel.style.maxHeight = '0px';
        }
    }
}

customElements.define('ultra-personal', UltraPersonal);
